import { combineReducers } from 'redux';

import jalesTransito from './jalesTransito/combineReducers';

export default combineReducers({
	jalesTransito,
});
